import { ISite } from 'src/domain/site/interface';

export enum MarketAwardSource {
    DAM = 'DAM',
    RTD = 'RTD',
    FMM = 'FMM',
}

export enum MarketAwardStatus {
    NEW = 'new',
    APPROVED = 'approved',
    DENIED = 'denied',
    AUTO = 'auto', // auto approved
    IGNORED = 'ignored', // expired
}

interface Resource {
    id: string;
    name: string;
    pmin: number;
    pmax: number;
    months: any[];
    date_modified: string;
    date_created: string;
}

export interface MarketAwardsDispatchEvent {
    start: string; // Date
    duration: number; // minutes
}

export interface MarketAwardsDispatch {
    id: string;
    siteIds: number[];
    event: MarketAwardsDispatchEvent;
}

export interface IMarketAward {
    id: string;
    source: MarketAwardSource;
    resourceName: string;
    resource?: Resource;
    sites: ILocationSite[];
    start: string;
    end: string;
    mw: number;
    price: number | null;
    earnings: number | null;
    status: MarketAwardStatus;
    dispatch?: MarketAwardsDispatch;
    date_modified: string;
    date_created: string;
}

export interface ILocationSite extends ISite {
    san?: string;
}
